export default args => {
    if (args.cell.properties.html) {
        const dom = document.createElement('div');
        dom.innerHTML = args.cell.properties.html;
        args.text = dom.innerText;
    }
    args.horizontalAlignment = 'center';
    args.backColor = args.cell.properties.barColor;
};
